import { render, staticRenderFns } from "./flfg.vue?vue&type=template&id=1a05b045&scoped=true&"
import script from "./flfg.vue?vue&type=script&lang=js&"
export * from "./flfg.vue?vue&type=script&lang=js&"
import style0 from "./flfg.vue?vue&type=style&index=0&id=1a05b045&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a05b045",
  null
  
)

export default component.exports